import { render, staticRenderFns } from "./Carousel2Images.vue?vue&type=template&id=2745125e&scoped=true"
import script from "./Carousel2Images.vue?vue&type=script&lang=js"
export * from "./Carousel2Images.vue?vue&type=script&lang=js"
import style0 from "./Carousel2Images.vue?vue&type=style&index=0&id=2745125e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2745125e",
  null
  
)

export default component.exports